module.exports = __webpack_public_path__ + "img/login.ed704bfa.png";